import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import './index.css';
import App from './App';
import { clerkAppearance } from './clerkAppearance';

const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const tree = publishableKey ? (
  <ClerkProvider publishableKey={publishableKey} appearance={clerkAppearance} afterSignOutUrl="/">
    <App />
  </ClerkProvider>
) : (
  // Graceful fallback: without a Clerk key the app still boots (demo mode).
  <App />
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>{tree}</React.StrictMode>);
